import './App.css';
import CustomNavBar from './components/CustomNavBar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Footer from './components/Footer';
import ContactUs from './components/ContactUs';
import Home from './pages/Home';
import OurTeam from './pages/OurTeam';
import InTheNews from './pages/InTheNews';
import ListFeaturedProperties from './pages/ListFeaturedProperties';
import SoldHomes from './pages/SoldHomes';
import AboutInfo from './pages/AboutInfo';
import Neighborhoods from './pages/Neighborhoods';




function App() {
  return (
    <Router>
    <div className="App">
      <CustomNavBar/>
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ourTeam" element={<OurTeam />} />
          <Route path="/inTheNews" element={<InTheNews />} />
          <Route path="/listFeaturedProperties" element={<ListFeaturedProperties />} />
          <Route path="/soldHomes" element={<SoldHomes />} />
          <Route path="/aboutInfo" element={<AboutInfo />} />
          <Route path="/neighborhoods" element={<Neighborhoods />} />
        </Routes>
      <ContactUs/>
      <Footer/>
    </div>
    </Router>
  );
}

export default App;
